import { PageContainer } from "@ant-design/pro-components";
import { Breadcrumb } from "antd";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import QuickActionButton from "../../components/common/QuickActionButton";
import TeamMemberTable from "../../components/teamMember/teamMemberTable";

export default function TeamMemberTablePage() {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <PageContainer className="w-full ">
      <div className="flex flex-col justify-between w-full gap-2 my-2 space-y-4 md:space-y-0 md:flex-row">
        <div className="text-2xl font-semibold leading-7 text-color-primary">
          <Breadcrumb
            separator=">"
            items={[
              {
                title: (
                  <div className="text-[#75757E]">
                    {intl.formatMessage({
                      id: "Settings",
                      defaultMessage: "الإعدادات",
                    })}
                  </div>
                ),
                href: "#",
                onClick: () => {
                  navigate("/settings");
                },
              },
              {
                title: (
                  <div className="text-color-primary">
                    {intl.formatMessage({
                      id: "teamMembers",
                      defaultMessage: "فريق العمل",
                    })}
                  </div>
                ),
              },
            ]}
          />
        </div>
        <div className="flex justify-end">
          <QuickActionButton />
        </div>
      </div>
      <div className="text-2xl font-semibold leading-7 text-color-primary">
        {intl.formatMessage({
          id: "yourSalonTeamMembers",
          defaultMessage: "فريق العمل الخاص بمشروعك",
        })}
      </div>
      <div className="my-4 text-base font-normal leading-7 text-color-gray ">
        {intl.formatMessage({
          id: "aboutYourTeam",
          defaultMessage: "كل ما يتعلق بأعضاء فريقك",
        })}
      </div>
      <div className="mt-6 ">
        <TeamMemberTable />
      </div>
    </PageContainer>
  );
}
